export type NonEmptyArray<T> = [T, ...T[]];
/**
 * Check if an array has at least one member.
 *
 * @param value - The array to check
 * @returns Whether or not the array has at least on member
 */
export function hasAtLeastOneItem<T>(value: T[]): value is NonEmptyArray<T> {
    return value.length > 0;
}

/**
 * Assert an array has at least one member.
 *
 * @param value - The array to check
 * @throws - Error('Expected array to have at least one item')
 */
export function assertHasAtLeastOneItem<T>(value: T[]): asserts value is NonEmptyArray<T> {
    if (!hasAtLeastOneItem(value)) {
        throw new Error('Expected array to have at least one item');
    }
}
